import React from 'react';
import { useController } from 'react-hook-form';

// components
import FormFieldLabel from '../FormFieldLabel';
import FormFieldError from '../FormFieldError';
import FormFieldDescription from '../FormFieldDescription';

const TextInput = ({ name, control, rules, label, type = 'text', prefix, description, config, ...props }) => {
    const {
        field,
        fieldState: { error }
    } = useController({
        name,
        control,
        rules
    });

    const handleChange = (e) => {
        if (type === 'numeric') {
            // For numeric inputs, filter to allow only valid numeric characters
            let value = e.target.value.replace(/[^0-9.-]/g, '');
            // Ensure only one decimal point
            const parts = value.split('.');
            if (parts.length > 2) {
                value = parts[0] + '.' + parts.slice(1).join('');
            }
            // Ensure minus sign only at the beginning
            value = value.replace(/-/g, (match, offset) => offset === 0 ? match : '');
            field.onChange(value);
        } else {
            field.onChange(e.target.value);
        }
    };

    const handleKeyDown = (e) => {
        if (type === 'numeric') {
            // Handle numeric input
            const allowedKeys = [
                'Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End',
                'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
            ];

            if (!allowedKeys.includes(e.key) &&
                !e.ctrlKey && !e.metaKey &&
                !/^[0-9.-]$/.test(e.key)) {
                e.preventDefault();
            }

            // Prevent multiple decimal points
            if (e.key === '.' && e.target.value.includes('.')) {
                e.preventDefault();
            }

            // Prevent multiple minus signs or minus not at the beginning
            if (e.key === '-') {
                if (e.target.value.includes('-') || e.target.selectionStart > 0) {
                    e.preventDefault();
                }
            }
        }
    };

    const inputType = type === 'numeric' ? 'text' : type;

    return (
        <div
            className={`FormField FormField--text FormField--${type}${prefix ? ' FormField--hasPrefix' : ''}`}
        >
            <FormFieldLabel label={label} name={name} rules={rules}/>
            <div className="FormField__inputWrapper">
                {prefix && <span className="FormField__prefix">{prefix}</span>}
                <input
                    {...props}
                    id={name}
                    type={inputType}
                    value={field.value || ''}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    inputMode={type === 'numeric' ? 'decimal' : undefined}
                    pattern={type === 'numeric' ? '[0-9.\\-]*' : undefined}
                />
            </div>
            {error ? (
                <FormFieldError error={error} />
            ) : (
                <FormFieldDescription description={description} />
            )}
        </div>
    );
}

export default TextInput;